import {
  IPayer,
  IPayerCreateRequest,
  IPayerUpdateRequest,
} from "types/Payers/Payers";
import { IPayerResponse } from "types/Payers/PayersResponse";

import { api } from ".";

const payerQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPayers: builder.query<any, void>({
      query: () => "payer/",
    }),
    getPayersByAccount: builder.query<any, string>({
      query: (accountId) => `payer/account/${accountId}`,
    }),
    // CLE-2658 — the payers the given providers currently have live. Callers should pass a
    // stable (sorted) list: RTK Query caches on the argument, so ["a","b"] and ["b","a"] would
    // otherwise be two cache entries for one answer.
    getPayersByProviders: builder.query<any, string[]>({
      query: (providerIds) => ({
        url: "payer/by-providers",
        params: { providerIds: providerIds.join(",") },
      }),
    }),
    getPayerById: builder.query<IPayerResponse, string | undefined>({
      query: (id: string) => `payer/${id}`,
    }),
    createPayer: builder.mutation<IPayer, IPayerCreateRequest>({
      query: (newPayer) => ({
        url: "payer/",
        method: "POST",
        body: newPayer,
      }),
    }),
    updatePayer: builder.mutation<IPayer, IPayerUpdateRequest>({
      query: (updatedPayer) => ({
        url: `payer/${updatedPayer.id}`,
        method: "PUT",
        body: updatedPayer,
      }),
    }),
    deletePayer: builder.mutation<any, string>({
      query: (id) => ({
        url: `payer/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllPayersQuery,
  useGetPayersByAccountQuery,
  useGetPayersByProvidersQuery,
  useDeletePayerMutation,
  useCreatePayerMutation,
  useGetPayerByIdQuery,
  useUpdatePayerMutation,
} = payerQueries;
